
import moment from 'moment';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router';
import { useLocation } from 'react-router-dom';

import './EIR.css'
import api from '../../components/services/api';
import { Textfit } from 'react-textfit';
export default function EIR() {
    const [data, setData] = useState('')

    const [groupData, setGroupData] = useState([
        {
            GroupId: "G001",
            GroupName: "รถ",
            GroupNo: "00001",
            Status: true,
            CreateID: null,
            CreateDate: "2022-12-28T05:00:15.567Z",
            ModifiedID: null,
            ModifiedDate: "2022-12-28T05:00:15.567Z"
        },
        {
            GroupId: "G002",
            GroupName: "รถไฟ",
            GroupNo: "00002",
            Status: true,
            CreateID: null,
            CreateDate: "2022-12-28T05:00:15.595Z",
            ModifiedID: null,
            ModifiedDate: "2022-12-28T05:00:15.595Z"
        },
        {
            GroupId: "G003",
            GroupName: "เรือ",
            GroupNo: "00003",
            Status: true,
            CreateID: null,
            CreateDate: "2022-12-28T05:00:15.621Z",
            ModifiedID: null,
            ModifiedDate: "2022-12-28T05:00:15.621Z"
        }
    ])
    let { id } = useParams();
    function useQuery() {
        const { search } = useLocation();

        return React.useMemo(() => new URLSearchParams(search), [search]);
    }
    let query = useQuery();


    const getdata = async () => {
        const res = await api.get(`api/workorder/detail/${id}?type=${query?.get('type') || ''}&eirNo=${query?.get('eirNo') || ''}`)
        const data = res?.data
        setData(data);
    }

    const getMasterGroup = async () => {
        const res = await api.get(`api/master/group`)
        const data = await res.data
        if (res.meta.status === true) {
            setGroupData(data.data)
        }
    }
    useEffect(() => {
        getdata()
        const style = document.createElement('style')
        style.innerHTML = `
        @page {
            margin: 0;
            size: 9in 5.5in;
          }`
        document.head.appendChild(style)
        // getMasterGroup()
    },
        [])
    // const pageCount = Math.ceil(data?.ContainerList?.length / 6)
    const rows = [];
    for (let pageIndex = 0; pageIndex < data?.ContainerList?.length; pageIndex++) {
        rows.push(<>

            <page className='eirReport' style={{
                width: '9in',
                height: '5.2in',
                padding: '0px',
            }}>
                <div class="header" style={{ margin: '20px 40px 10px 20px' }}>
                    <img src="/images/logo2.png" class="logo" style={{ width: "130px" }} />
                    <div className="header_title" style={{ marginTop: "0px" }}>
                        <p style={{ fontSize: "22px", fontWeight: "bold", marginBottom: '0px' }}>SRITRANG LOGISTIC COMPANY LIMITED</p>
                        <p style={{ fontSize: "22px", fontWeight: "bold", marginBottom: '0px' }}>บริษัท ศรีตรังโลจิสติกส์ จำกัด </p>
                    </div>
                </div>
                <div style={{ margin: '10px 60px 10px 20px', display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: '100%', height: '1px', background: "#000" }} />
                    <p style={{ fontSize: "22px", fontWeight: "bold", marginBottom: '0px' }}>EQUIPMENT INTERCHANGE RECEIPT (E.I.R)</p>
                    {/* <p style={{fontSize:"20px", fontWeight:"bold"}}>Equipment InterChange Receipt(E.I.R) / {query.get('type') === 'MT' ? 'Empty' : 'Laden'}</p> */}
                    <div style={{ width: '100%', height: '1px', background: "#000" }} />

                </div>
                <div class="content_EIR" style={{ margin: '0px 40px' }}>
                    <div className="rowR" style={{ flexBasis: "0%", alignItems: "center" }}>
                        <p className='header_p' style={{ width: '175px', maxWidth: "175px" }}>CUSTOMER NAME :</p>
                        {/* <p style={{ fontSize: `${fontSize}px` }}
                        // style={{
                        //     flexBasis: "63%",
                        //     // display: "-webkit-box",
                        //     // WebkitBoxOrient: "vertical",
                        //     // WebkitLineClamp: "1",
                        //     // overflow: "hidden",
                        //     fontSize: 'min(5vw, 1.em)'
                        // }}
                        >
                            {updateFontSize(data?.CustomerName)} </p> */}
                        <span style={{ width: '313px', maxWidth: "313px", fontWeight: "bold" }}>
                            <Textfit mode="single" min={13} max={22} >
                                {data?.CustomerName}
                                {/* updateFontSize(data?.Customer */}
                            </Textfit>
                        </span>

                    </div>
                    <div className="rowR">
                        <p className='header_p' style={{ flexBasis: "25%" }}>DATE :</p>
                        <p style={{ flexBasis: "75%" }}>{query.get('type') === 'MT' ? data?.ContainerList[pageIndex]?.PickupDate ? moment(data?.ContainerList[pageIndex]?.PickupDate).format('yyyy/MM/DD') : '' : data?.ContainerList[pageIndex]?.ReturnDate ? moment(data?.ContainerList[pageIndex]?.ReturnDate).format('yyyy/MM/DD') : ''}</p>
                    </div>
                    <div className="rowR" style={{ flexBasis: "0%", alignItems: "center" }}>
                        <p className='header_p' style={{ width: '175px', maxWidth: "175px" }}>SHIPPER REF NO. :</p>
                        <span style={{ width: '313px', maxWidth: "313px", fontWeight: "bold" }}>
                            <Textfit mode="single" min={13} max={22} >
                                {data?.ShipperRefNo}
                            </Textfit>
                        </span>
                    </div>
                    <div className="rowR" style={{ flexBasis: "35%" }}>
                        <p className='header_p' style={{ flexBasis: "25%" }}>TIME :</p>
                        <p style={{ flexBasis: "75%" }}>{query.get('type') === 'MT' ? data?.ContainerList[pageIndex]?.PickupTime : data?.ContainerList[pageIndex]?.ReturnTime}</p>
                    </div>
                    <div className="rowR">
                        <p className='header_p'>BOOKING NO. :</p>
                        <p>{data?.BookingNo}</p>
                    </div>
                    <div className="rowR">
                        <p className='header_p'>DOCUMENT NO. :</p>
                        <p>{query.get('type') === 'MT' ? data?.ContainerList[pageIndex]?.EIRNo : data?.ContainerList[pageIndex]?.EIRNoLaden}</p>
                    </div>
                    <div className="rowR" style={{ alignItems: 'center' }}>
                        <p className='header_p' style={{ width: '175px', maxWidth: "175px" }}>SHIPPING LINE :</p>
                        <span style={{ width: '186px', maxWidth: "186px", fontWeight: "bold" }}>
                            <Textfit mode="single" min={13} max={22} >
                                {data?.ShippingLine}
                                {/* updateFontSize(data?.Customer */}
                            </Textfit>
                        </span>
                        {/* <p style={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: "1",
                            overflow: "hidden",
                        }}>{data?.ShippingLine}</p> */}
                    </div>
                    <div className="rowR">
                        <p className='header_p'>TRANSPORTATION :</p>
                        <p>{groupData?.find((x) => x.GroupId === data?.InboundTransportGroupId)?.GroupName} </p>
                    </div>


                </div>
                <div class="content_center" style={{ margin: '0px 40px' }}>
                    <div className="rowR">
                        <p className='header_p'>CONTAINER NO. :</p>
                        <p>{data?.ContainerList[pageIndex]?.ContainerNo}</p>
                    </div>
                    <div class="rowR">
                        <p className='header_p'>SIZE :</p>
                        <p>{data?.Size}</p>
                    </div>
                    <div class="rowR">
                        <p className='header_p'>{query.get('type') === 'MT' ? 'GATE OUT :' : 'GATE IN :'} </p>
                        <p>{data?.InboundGateOut}</p>
                    </div>
                </div>
                <div class="content_center" style={{ margin: '0px 40px' }}>
                    <div className="rowR" style={{ alignItems: 'center', flexBasis: "0%", }}>
                        <p className='header_p' style={{ width: "175px", maxWidth: "175px", minWidth: '175px' }}>SEAL NO. :</p>
                        <span style={{ width: "80px", maxWidth: '80px', marginRight: "0px", fontWeight: "bold" }}>
                            <Textfit mode="single" min={13} max={22} >
                                {data?.ContainerList[pageIndex]?.SealCarrierNo}
                            </Textfit>
                        </span>
                    </div>
                    <div class="rowR" style={{ alignItems: 'center', flexBasis: "0%", }}>
                        <p className='header_p' style={{ width: "109px", maxWidth: "109px" }}>NET WEIGHT :</p>
                        <span style={{ width: "68px", maxWidth: '68px', minWidth: '68px', marginRight: '0px', fontWeight: "bold" }}>
                            <Textfit mode="single" min={13} max={22} >
                                {data?.ContainerList[pageIndex]?.VGMWeight || ''}
                            </Textfit>
                        </span>
                    </div>
                    <div class="rowR" style={{ alignItems: 'center', flexBasis: "0%", }}>
                        <p className='header_p' style={{ width: "97px", maxWidth: "97px", minWidth: '97px' }}>VOYAGE NO. :</p>
                        <span style={{ width: "175px", maxWidth: "175px", fontWeight: "bold" }}>
                            <Textfit mode="single" min={13} max={22} >
                                {data?.ContainerList[pageIndex]?.VoyOut || '-'}
                            </Textfit>
                        </span>
                    </div>
                </div>

                <div class="content_EIR" style={{ margin: '0px 40px' }}>
                    <div className="rowR" style={{ flexBasis: "0%", alignItems: "center" }}>
                        <p className='header_p' style={{ width: '175px', maxWidth: "175px" }}>TRUCK COMPANY :</p>
                        <span style={{ width: '295px', maxWidth: "295px", fontWeight: "bold" }}>
                            <Textfit mode="single" min={13} max={22} >
                                {query.get('type') === 'MT' ? data?.ContainerList[pageIndex]?.VenderMT : data?.ContainerList[pageIndex]?.Vender}
                            </Textfit>
                        </span>
                    </div>
                    <div className="rowR" style={{ flexBasis: "25%" }}>
                        <p className='header_p'>STATUS :</p>
                        <p>{data?.ContainerStockType}</p>
                    </div>
                    <div className="rowR">
                        <p className='header_p'>TRUCK NO. :</p>
                        <p>{query.get('type') === 'MT' ? data?.ContainerList[pageIndex]?.PickupTruckNo : data?.ContainerList[pageIndex]?.ReturnTruckNo}</p>
                    </div>
                    <div className="rowR">
                        <p className='header_p'>GENDER :</p>
                        <p>{query.get('type') === 'MT' ? 'Empty' : 'Laden'}</p>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: "25px" }}>
                    <p style={{ fontSize: "22px", fontWeight: "bold" }}>-------------กรุณาตรวจสอบเอกสาร/ตรวจสอบสภาพตู้สินค้าทุกครั้ง-------------</p>
                </div>
                <div class="content_footer" style={{ marginTop: '10px' }}>
                    <div className="rowR">
                        <p style={{ lineHeight: '24px' }}>…...........................................................................</p>
                        <p style={{ fontWeight: "bold" }}>DRIVER NAME</p>
                    </div>
                    <div className="rowR">
                        <p style={{ lineHeight: '24px' }}>…...........................................................................</p>
                        <p style={{ fontWeight: "bold" }}>TERMINAL SIGNATURE
                        </p>
                    </div>
                </div>
                <div class="footer_S" style={{ paddingLeft: '20px', paddingRight: "80px", }}>
                    <p style={{ marginBottom: '0px', fontWeight: "bold" }}>SRITRANG LOGISTIC COMPANY LIMITED</p>
                    <p style={{ marginBottom: '0px', fontWeight: "bold" }}> F-CY-003 ฉบับแก้ไขครั้งที่ 4 วันที่อนุมัติใช้ 01 พฤศจิกายน 2566 </p>
                </div>
            </page >
            <div style={{ pageBreakAfter: 'always' }}></div>
        </>
        )
    }
    return (
        <>
            {rows}
        </>
    )
}
